import React, { useEffect, useMemo, useRef, useState } from 'react';
import { SplitClient } from '../services/SplitClient';
import { FeatureFlagsContext } from './FeatureFlagsContext';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const FeatureFlags = _ref => {
  let {
    authorizationKey,
    children,
    courseId,
    extraAttributes,
    user
  } = _ref;
  const [context, setContext] = useState({
    loading: true
  });
  const initialAttributes = useRef(extraAttributes);
  const client = useMemo(() => {
    return new SplitClient(user, authorizationKey, initialAttributes.current);
  }, [user, authorizationKey]);
  useEffect(() => {
    client.start().then(() => setContext({
      client,
      loading: false
    })).catch(error => setContext({
      client,
      error,
      loading: false
    }));
  }, [client]);
  useEffect(() => {
    client.setCourseId(courseId);
  }, [client, courseId]);
  useEffect(() => {
    if (extraAttributes != null) {
      client.setExtraAttributes(extraAttributes);
    }
  }, [client, extraAttributes]);
  return ___EmotionJSX(FeatureFlagsContext.Provider, {
    value: context
  }, children);
};